import React, { createContext, useContext, useReducer, useEffect } from 'react';
import { LANGUAGES, STORAGE_KEYS } from '../constants';

const AppContext = createContext();

const initialState = {
  language: LANGUAGES.DEFAULT,
  loading: false,
  error: null,
  orderData: null,
};

const appReducer = (state, action) => {
  switch (action.type) {
    case 'SET_LANGUAGE':
      return { ...state, language: action.payload };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_ERROR':
      return { ...state, error: action.payload };
    case 'SET_ORDER_DATA':
      return { ...state, orderData: action.payload };
    case 'CLEAR_ERROR':
      return { ...state, error: null };
    default:
      return state;
  }
};

export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  useEffect(() => {
    try {
      const savedLang = localStorage.getItem(STORAGE_KEYS.LANGUAGE);
      if (savedLang) {
        dispatch({ type: 'SET_LANGUAGE', payload: savedLang });
      }
    } catch (error) {
      console.error('Failed to load language from localStorage:', error);
    }
  }, []);

  const setLanguage = (language) => {
    try {
      localStorage.setItem(STORAGE_KEYS.LANGUAGE, language);
      dispatch({ type: 'SET_LANGUAGE', payload: language });
    } catch (error) {
      console.error('Failed to save language to localStorage:', error);
      // Still update state even if localStorage fails
      dispatch({ type: 'SET_LANGUAGE', payload: language });
    }
  };

  const setLoading = (loading) => {
    dispatch({ type: 'SET_LOADING', payload: loading });
  };

  const setError = (error) => {
    dispatch({ type: 'SET_ERROR', payload: error });
  };

  const clearError = () => {
    dispatch({ type: 'CLEAR_ERROR' });
  };

  const setOrderData = (data) => {
    dispatch({ type: 'SET_ORDER_DATA', payload: data });
  };

  const value = {
    ...state,
    setLanguage,
    setLoading,
    setError,
    clearError,
    setOrderData,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within AppProvider');
  }
  return context;
};